var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"mb-3 flex justify-end"},[_c('vs-button',{attrs:{"color":"success","type":"flat","size":"small","disabled":!_vm.str.length || !_vm.notification},on:{"click":_vm.copy}},[_vm._v(_vm._s(_vm.$t('tooltip.Copy')))])],1),_c('highlight-code',{attrs:{"lang":"json"}},[_vm._v(_vm._s(_vm.str))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }